import { T_COLOR_SHADES } from '@styles/colors/themes/beam/beam-flat';
import { EquipmentIdentificationStatus } from '@models/Equipment.model';
import { Falsey, IStatuses } from './AssetMatchLabel.types';

export const statuses: IStatuses = {
  [EquipmentIdentificationStatus.Identified]: {
    icon: 'tick-circle',
    label: 'Identified',
  },
  [EquipmentIdentificationStatus.Inventory]: {
    icon: 'info-sign',
    label: 'Internal',
  },
  [EquipmentIdentificationStatus.IdentificationRequested]: {
    icon: 'history',
    label: 'Requested',
  },
  [EquipmentIdentificationStatus.Error]: {
    icon: 'error',
    label: 'Error',
  },
  [EquipmentIdentificationStatus.Discarded]: {
    icon: 'error',
    label: 'Discarded',
  },
  [EquipmentIdentificationStatus.Unidentified]: {
    icon: 'error',
    label: 'Unidentified',
  },
};
export function getAssetMatchStatus(
  status: EquipmentIdentificationStatus | Falsey,
) {
  return status || EquipmentIdentificationStatus.Unidentified;
}
export function getAssetMatchIconColor(
  status: EquipmentIdentificationStatus | Falsey,
): T_COLOR_SHADES {
  if (status === EquipmentIdentificationStatus.Identified) return 'n800';
  if (status === EquipmentIdentificationStatus.Inventory) return 'n800';
  if (status === EquipmentIdentificationStatus.IdentificationRequested) {
    return 'n600';
  }

  return 'n600';
}
